'use client'

import { createContext, useContext, useEffect } from 'react'
import { TagCommanderContext } from '../TagCommander'

interface HotjarProps {
  children: React.ReactNode
}

interface HotjarContextProps {
  pushDataToHotjar?: (tcVars: string) => void
}

export const HotjarContext = createContext<HotjarContextProps>({})

const Hotjar: React.FC<HotjarProps> = ({ children }) => {
  const { tcVars } = useContext(TagCommanderContext)
  const pushDataToHotjar = (tcVars: string) => {
    const structData = JSON.parse(tcVars)
    if (structData?.contact_id && !!window.hj) {
      const rawCustomAttributes = {
        domiciliation_id: structData.domiciliation_id,
        domiciliation_legal_status: structData.domiciliation_legal_status
      }
      const customAttributes = Object.fromEntries(
        Object.entries(rawCustomAttributes).filter(
          ([_key, value]) => value !== undefined
        )
      )
      window.hj('identify', structData.contact_id, customAttributes)
    }
  }

  useEffect(() => {
    if (tcVars) {
      pushDataToHotjar(tcVars)
    }
  }, [tcVars])

  return (
    <HotjarContext.Provider value={{ pushDataToHotjar }}>
      {children}
    </HotjarContext.Provider>
  )
}

export default Hotjar
